module.exports = __webpack_public_path__ + "img/fb11.d30e4f42.jpg";